<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-12 bg-silver mt-3">
                <app-search-filter :query="query"></app-search-filter>
            </div>
            <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12">
                <div class="row">
                    <app-item v-for="(item, index) in theItemsOnDisplay" :key="index" :item="item"></app-item>
                </div>
            </div>
        </div>

        <!-- infinite scroller work on me somemore or remove me
        <app-infinite-scroller></app-infinite-scroller> -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle, capitalizeWord } from '@/store/dry'

import Item from '../shared/Item.vue'
import SearchFilter from './searchParts/SearchFilter.vue'
import InfiniteScroller from '@/components/general/shared/InfiniteScroller.vue'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: 'SiteSearch',
    props: {
        query: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['fullfilSearchAction']),
        fullfilSearchFxn(theQuery) {
            let searchObj = {
                query: theQuery
            }
            this.fullfilSearchAction(searchObj).then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['itemsOnDisplay']),
        theItemsOnDisplay() {
            if(this.itemsOnDisplay){
                return this.itemsOnDisplay
            }
            return false
        }
    },
    components: {
        appItem: Item,
        appSearchFilter: SearchFilter,
        appInfiniteScroller: InfiniteScroller
    },
    watch: {
        query() {
            this.fullfilSearchFxn(this.query)
        }
    },
    created() {
        webpageTitle(capitalizeWord(this.query))
        this.fullfilSearchFxn(this.query)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>